/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".token-input[_ngcontent-%COMP%]{background:0 0;text-align:center;border:none;border-bottom:2px solid}.help[_ngcontent-%COMP%]{position:absolute;top:-14px;width:100%;text-align:center;font-size:20px;color:#ffb18b}"];
export { styles as styles };
